import { createContext } from "react";
export var SafeAreaContext = createContext({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    override: false,
});
